import { apiFetch } from "./client";

/**
 * Phase 3.X-1B sub_3 — NeedsReview QUEUE (GET /Custom/frontend/needs-review).
 *
 * Business profiles still awaiting manager review (A3 Gate v2). Backend owns
 * ACL/scope, cursor pagination, branch + branch-specific missingRequiredCount
 * (via ProfileReviewService). Rows link to the A3 gate at
 * /clients/:holdingId/business-profile. row_visibility is enforced server-side.
 */

export type NeedsReviewScope = "my" | "team" | "all";

export interface NeedsReviewRow {
  profileId: string;
  holdingId: string | null;
  clientDisplayName: string;
  partyType: string;
  primaryBusinessModel: string;
  branch: "breeder" | "commercial_non_breeder";
  missingRequiredCount: number;
  reviewStatus: string;
  manager: string;
  updatedAt: string | null;
}

export interface NeedsReviewResponse {
  items: NeedsReviewRow[];
  nextCursor: string | null;
  totalVisibleCount: number;
  allowedScopes: NeedsReviewScope[];
  defaultScope: NeedsReviewScope;
  appliedScope: NeedsReviewScope;
  managers: Array<{ id: string; name: string }>;
  allowedActions: { canOpenBusinessProfile: boolean; canReview: boolean };
}

export interface NeedsReviewQuery {
  cursor?: string;
  limit?: number;
  scope?: NeedsReviewScope | "";
  manager?: string;
}

export function fetchNeedsReview(
  q: NeedsReviewQuery = {},
  signal?: AbortSignal,
): Promise<NeedsReviewResponse> {
  return apiFetch<NeedsReviewResponse>("/Custom/frontend/needs-review", {
    query: {
      cursor: q.cursor || undefined,
      limit: q.limit,
      scope: q.scope || undefined,
      manager: q.manager || undefined,
    },
    signal,
  });
}
